<mat-toolbar class="header mat-elevation-z1">
    <span >
        <a routerLink="/" >
            <img class="logo" src="assets/img/logoKironADM.png" alt="logo" style="padding-left: 25px; min-height: 45px;">
        </a>
    </span>
</mat-toolbar>